import Box from "@mui/material/Box/Box";
import {theme} from "../../../../../_fri/themes/theme";
import {Button} from "@mui/material";
import {FriButtonIcon} from "../../../../../_fri/icons/FriButtonIcon";
import {useEffect, useState} from "react";
import {EcommerceDashboardModalFindUser} from "../ecommerce-dasbhoard-modal-find-user/EcommerceDashboardModalFindUser";
import {EcommerceDashboardModalPayment} from "../ecommerce-dasbhoard-modal-payment/EcommerceDashboardModalPayment";
import {Transaction} from "../../../../../store/api/interface/ecommerce";
import {initTransaction} from "../../../../../_fri/utils/enum";
interface IEcommerceDashboardDetailBodyPayment {
    valuePayment:string
}
export const EcommerceDashboardDetailBodyPayment = ({valuePayment}:IEcommerceDashboardDetailBodyPayment) => {
    const [showModalFindFriUser, setShowModalFindFriUser] = useState(false);
    const [showModalPayment, setShowModalPayment] = useState(false);
    const [transaction, setTransaction] =useState<Transaction>(initTransaction);

    return (
        <>
            <Box sx={{display: "flex", marginTop: "0.4rem", alignItems: "center", flexWrap: "wrap"}}>

                <Box sx={{fontSize: "1.1rem", fontWeight: theme.typography.fontWeightRegular, marginRight: "5rem"}}>
                    Selecciona el método de pago
                </Box>

                <Box sx={{marginRight: "1rem", marginTop: "0.5rem"}}>
                    <Button variant="contained"
                            sx={{
                                width: "6.5rem",
                                height: "3.5rem",
                                borderRadius: "0.5rem"
                            }}
                            color="success"
                    >
                        Efectivo
                    </Button>
                </Box>

                <Box sx={{marginRight: "1rem", marginTop: "0.5rem"}}>
                    <Button
                        variant="contained"
                        sx={{
                            width: "6.5rem",
                            height: "3.5rem",
                            borderRadius: "0.5rem"
                        }}
                        color="warning">
                        Tarjeta de
                        crédito/débito
                    </Button>
                </Box>

                <Box sx={{marginRight: "1rem", marginTop: "0.5rem"}}>
                    <Button
                        variant="contained"
                        sx={{
                            width: "6.5rem",
                            height: "3.5rem",
                            borderRadius: "0.5rem",
                            backgroundColor: "rgba(25,141,255,0.35)"
                        }}
                        color="primary"
                        onClick={()=> setShowModalFindFriUser(true)}
                    >
                        <FriButtonIcon/>
                    </Button>
                </Box>

            </Box>
            <EcommerceDashboardModalFindUser
                openLoader={()=>setShowModalPayment(true)}
                show={showModalFindFriUser}
                close={()=> setShowModalFindFriUser(false)}
                setTransaction={setTransaction}
                valuePayment={valuePayment}
            />
            <EcommerceDashboardModalPayment
                show={showModalPayment}
                close={()=> setShowModalPayment(false)}
                transaction={transaction}
                updateTransaction={setTransaction}
            />
        </>
    );
};